function slice(name: string, size: number) {
    if (name?.length <= size) {
        return name;
    } else {
        return name?.slice(0, size) + '...';
    }
}
export default slice